import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/ru";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("ru");

export const MSK_TZ = "Europe/Moscow";
export default dayjs;

export function formatDateTimeForUi(value: string) {
  const parsed = dayjs.utc(value);

  if (!parsed.isValid()) return value;

  return parsed.tz(MSK_TZ).format("DD.MM.YYYY, HH:mm");
}
